const TabsHandlerProvider = () => {
    return <></>;
};

export default TabsHandlerProvider;
